import { Box, Container, Stack, Typography, Link, IconButton } from "@mui/material";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Link as RouterLink } from "react-router-dom";
import logo from "../static/media/logo2.webp";

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        color: "#ffffff",
        background: "linear-gradient(180deg, #e50914 0%, #0b0b0f 100%)",
        borderTop: "1px solid rgba(255,255,255,0.08)",
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          width: { xs: "90%", md: "82%" },
          py: { xs: 4.5, md: 5.5 },
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1.2fr 0.8fr 0.8fr" },
            gap: { xs: 3, md: 4 },
            alignItems: "start",
          }}
        >
          <Stack spacing={1.6} sx={{ alignItems: { xs: "center", md: "flex-start" }, textAlign: { xs: "center", md: "left" } }}>
            <Box
              component="img"
              src={logo}
              alt="NovaXFit"
              sx={{
                height: { xs: 60, md: 80 },
                width: "auto",
                display: "block",
              }}
            />

            <Stack spacing={1.2}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: { xs: "center", md: "flex-start" },
                  gap: 1,
                }}
              >
                <MailOutlineRoundedIcon sx={{ fontSize: 18, color: "rgba(255,255,255,0.9)" }} />
                <Link
                  href="mailto:inscripciones@nova-fit.com"
                  underline="none"
                  sx={{
                    color: "rgba(255,255,255,0.88)",
                    fontSize: 14.5,
                    fontWeight: 600,
                    "&:hover": { color: "#ffffff" },
                  }}
                >
                  Inscripciones
                </Link>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: { xs: "center", md: "flex-start" },
                  gap: 1,
                }}
              >
                <LocalPhoneRoundedIcon sx={{ fontSize: 18, color: "rgba(255,255,255,0.9)" }} />
                <Link
                  href="tel:0985224301"
                  underline="none"
                  sx={{
                    color: "rgba(255,255,255,0.88)",
                    fontSize: 14.5,
                    fontWeight: 600,
                    "&:hover": { color: "#ffffff" },
                  }}
                >
                  0985224301
                </Link>
              </Box>
            </Stack>

            <Stack direction="row" spacing={1.2} sx={{ mt: 1 }}>
              <IconButton
                component="a"
                href="https://www.facebook.com/novagym.ec/?locale=es_LA"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook NovaGym"
                title="Facebook NovaGym"
                sx={{
                  bgcolor: "#ffffff",
                  width: 42,
                  height: 42,
                  "&:hover": {
                    bgcolor: "#1877F2",
                    "& svg": { color: "#ffffff" },
                  },
                }}
              >
                <FacebookRoundedIcon sx={{ color: "#1877F2" }} />
              </IconButton>

              <IconButton
                component="a"
                href="https://www.instagram.com/novaxfit_center/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram NovaXFit Center"
                title="Instagram NovaXFit Center"
                sx={{
                  bgcolor: "#ffffff",
                  width: 42,
                  height: 42,
                  "&:hover": {
                    bgcolor: "#E1306C",
                    "& svg": { color: "#ffffff" },
                  },
                }}
              >
                <InstagramIcon sx={{ color: "#E1306C" }} />
              </IconButton>

              <IconButton
                component="a"
                href="https://www.instagram.com/novaxfit_evolution/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram NovaXFit Evolution"
                title="Instagram NovaXFit Evolution"
                sx={{
                  bgcolor: "#ffffff",
                  width: 42,
                  height: 42,
                  "&:hover": {
                    bgcolor: "#E1306C",
                    "& svg": { color: "#ffffff" },
                  },
                }}
              >
                <InstagramIcon sx={{ color: "#E1306C" }} />
              </IconButton>
            </Stack>
          </Stack>

          <Stack spacing={1.2} sx={{ alignItems: { xs: "center", md: "flex-start" }, textAlign: { xs: "center", md: "left" } }}>
            <Typography sx={{ fontSize: 15, fontWeight: 800 }}>
              Páginas
            </Typography>

            {[
              { label: "Inicio", to: "/" },
              { label: "Acerca de nosotros", to: "/acerca-de-nosotros" },
              { label: "Tienda", to: "/tienda" },
              { label: "Entrena mejor", to: "/entrenamiento" },
              { label: "Aliados", to: "/nuestros-aliados" },
              { label: "Contacto", to: "/contacto" },
            ].map((item) => (
              <Link
                key={item.label}
                component={RouterLink}
                to={item.to}
                underline="none"
                sx={{
                  color: "rgba(255,255,255,0.85)",
                  fontWeight: 600,
                  fontSize: 14.5,
                  "&:hover": { color: "#ffffff" },
                }}
              >
                {item.label}
              </Link>
            ))}
          </Stack>

          <Stack spacing={1.2} sx={{ alignItems: { xs: "center", md: "flex-start" }, textAlign: { xs: "center", md: "left" } }}>
            <Typography sx={{ fontSize: 15, fontWeight: 800 }}>
              Legal
            </Typography>

            <Link
              component={RouterLink}
              to="/politicas-de-privacidad"
              underline="none"
              sx={{
                color: "rgba(255,255,255,0.85)",
                fontWeight: 600,
                fontSize: 14.5,
                "&:hover": { color: "#ffffff" },
              }}
            >
              Políticas de privacidad
            </Link>

            <Link
              component={RouterLink}
              to="/terminos-y-condiciones"
              underline="none"
              sx={{
                color: "rgba(255,255,255,0.85)",
                fontWeight: 600,
                fontSize: 14.5,
                "&:hover": { color: "#ffffff" },
              }}
            >
              Términos y condiciones
            </Link>
          </Stack>
        </Box>

        <Box
          sx={{
            mt: { xs: 3, md: 4 },
            pt: { xs: 2, md: 2.2 },
            borderTop: "1px solid rgba(255,255,255,0.10)",
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: 14,
              color: "rgba(255,255,255,0.78)",
              fontWeight: 600,
            }}
          >
            © {new Date().getFullYear()} NovaXFit. Todos los derechos reservados.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}